import React, { useEffect } from "react";
import NewsLogoSection from "./NewsLogoSection";
import CategoriesCampaigns from "./CategorieCampaigns";
import OurImpact from "./OurImpact";
import LiveDonationFeed from "./LiveDonationFeed";
import TestimonialSection from "./TestimonialSection";
import HeroSection from "./heroSection";
import StartNewCampaign from "./StartNewCampaign";
import MonthlyDonationProgram from "./MonthlyDonationProgram";
import FeaturedOnHeading from "../../components/common/FeaturedOnHeading";
import AwardsSection from "./AwardsSection";
import { useDispatch } from "react-redux";
import { fetchCmsHomeAction } from "../../store/slices/cmsSlice";

const Index = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCmsHomeAction());
  }, [dispatch]);
  return (
    <>
      <HeroSection />
      <CategoriesCampaigns />
      <MonthlyDonationProgram />
      <StartNewCampaign />
      <OurImpact />
      <TestimonialSection />
      <LiveDonationFeed />
      <AwardsSection />
      <FeaturedOnHeading />
      <NewsLogoSection isHomePage={true} />
    </>
  );
};

export default Index;
